import { point } from "@turf/helpers";
import { Category, LocationType, Type } from "../../Models/GeocodeResponse.js";

export class GtfsTransformationService {
  /**
   * Transform the given GTFS data into a list of geocoding result features.
   * @param {GtfsStop[]} gtfsData GTFS data
   * @returns {GeocodeResultFeatures} Geocoding result
   */
  transformGtfsData(gtfsData, stationLimit, othersLimit, resultLimit) {
    return this._limitResultsByType(gtfsData, stationLimit, othersLimit)
      .map((gtfsItem) => {
        const { location_type, stop_code, stop_id, stop_lat, stop_lon, stop_name } = gtfsItem.attributes;
        return point([stop_lon, stop_lat], {
          category: Category.BUS_STOP,
          displayText: `${stop_code} - ${stop_name}`,
          locationType: location_type,
          name: stop_name,
          stopCode: stop_code,
          stopId: stop_id,
          type: Type.GTFS,
        });
      })
      .slice(0, resultLimit);
  }

  /**
   * Transform the Mapbox feature into a geocoding result.
   * @param {GtfsStop[]} data GTFS data
   * @param {number} stationLimit The maximum number of stations to include in the result
   * @param {number} othersLimit The maximum number of non-stations to include in the result
   * @returns {GtfsStop[]} The combined result after trimming by given limits
   * @private
   */
  _limitResultsByType(data, stationLimit, othersLimit) {
    const stations = [];
    const others = [];
    for (const gtfsItem of data) {
      const isStation = this._isStationAsNumber(gtfsItem);
      if (isStation && stations.length < stationLimit) {
        stations.push(gtfsItem);
      } else if (!isStation && others.length < othersLimit) {
        others.push(gtfsItem);
      }

      if (stations.length >= stationLimit && others.length >= othersLimit) {
        break;
      }
    }
    return stations.concat(others);
  }

  /**
   * Checks if GTFS data has location_type of STATION.
   * @param {GtfsStop} data GTFS data
   * @returns {number} Returns 1 if GTFS data is a station, otherwise 0
   * @private
   */
  _isStationAsNumber(data) {
    return (data?.attributes?.location_type === LocationType.STATION) | 0;
  }
}
